// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__OOMod","additionalInfo":"AgreementModal_additionalInfo__1TsIj"};